import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useUser } from "../../redux/services/authSlice";
import { getBalance } from "../../redux/services/balanceSlice";
import Table from "../../common/Table";
import moment from "moment-timezone";
import { convertUtcToIst } from "../../common/TimeUtils";
import { exportToTablePDF } from "../../common/PdfFormat";

const Balance = () => {
  const dispatch = useDispatch();
  const { user } = useUser();
  const getBalanceData = useSelector((state) => state?.balance?.balanceData);
  const getAllBalance = useCallback(async () => {
    try {
      await dispatch(
        getBalance({ userFilter: user._id, typeFilter: "deposit" })
      );
    } catch (error) {}
  }, [dispatch, user]);

  useEffect(() => {
    getAllBalance();
  }, [getAllBalance]);
  const columns = [
    {
      header: "S/N",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    { header: "Name", key: "name", render: (_, row) => row.name || "" },
    {
      header: "Date",
      key: "updatedAt",
      render: (_, row) =>
        row.updatedAt
          ? moment(convertUtcToIst(row.updatedAt)).format("DD-MM-YYYY")
          : "-",
    },
    { header: "Type", key: "type",
      render: (_, row) => row.type || ""
     },
    { header: "Amount", key: "amount",
      render: (_, row) => row.amount || ""
     },
  ];
  const exportToPDF = () => {
    const headersConfig = [
      {
        label: "S/N",
        key: "index",
        render: (_, __, index) => index + 1,
      },
      { label: "Name", key: "name", render: (_, row) => row.name || "" },
      {
        label: "Date",
        key: "updatedAt",
        render: (_, row) =>
          row.updatedAt
            ? moment(convertUtcToIst(row.updatedAt)).format("DD-MM-YYYY")
            : "-",
      },
      { label: "Type", key: "type",
        render: (_, row) => row.type || ""
       },
      { label: "Amount", key: "amount",
        render: (_, row) => row.amount || ""
       },
    ];
    const data = getBalanceData?.balance_data || [];
    exportToTablePDF({
      tableName: "Deposit Data",
      data,
      headersConfig,
      pdfName: "deposit_data.pdf",
    });
  };
  return (
    <div>
      <Table
        title="Deposit"
        columns={columns}
        data={getBalanceData?.balance_data}
        exportButton={true}
        onExport={exportToPDF}
      />
    </div>
  );
};

export default Balance;
